module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter One")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("E")])]), _vm._v("va placed a tray of cut dough in the oven and then peered out the window. The wind moaned, making snow swirl against a gray January afternoon sky. The weather might not be as horrible as predicted, but it was bad enough to cancel school on a Friday. In northern Michigan that was pretty bad. As she cleaned off her flour-covered workspace at the island counter, a knock at the door made her jump.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Wiping damp hands against the back of her jeans, Eva crossed the kitchen floor and opened the door. A man with blue eyes the color of laser beams stood on the porch.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Eve Marsh?” He smiled at her. A devastatingly handsome smile.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s Eva.” Since when did she sound so out of breath?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He held out his hand. “I’m Adam. Adam Peece.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eva sucked in the gasp ready to escape. She’d accepted the job he’d offered over the phone this very morning.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sorry about not calling before dropping by, but I was on my way to the area and made better time than I thought. Last-minute decision.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_vm._v("Regardless of the high opinion her father had for the guy who’d bought the family cherry orchard, one look at Adam Peece and Eva knew he was not the kind of guy ")]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("she’d trust. He was too polished, too good-looking, and his fingers didn’t look as if they’d ever been dirty.")])]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He grinned as he let his hand drop. “Is this a bad time?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eva thought briefly about closing the door on him but backed up instead. “Oh, no. Sorry. Come in and let me take your coat.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He shrugged out of an expensive black wool peacoat, revealing snug black jeans topped by a charcoal-gray sweater. He looked as if he’d stepped off the pages of a fashion magazine. His build was slender but obviously well exercised. The sleek boots gave him the decided air of a European jet-setter.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And this guy wanted her to teach him to grow cherries? No way. A downstater like him was bound to ruin the orchard, change it or worse—develop it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He stepped farther into the kitchen. “Something smells incredible.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eva hesitated.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But her roommate, Beth, who sat at the kitchen table with her second-grade lesson plans, popped up to play hostess. “Eva’s famous cherry scones. Would you like one with coffee?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His grin was quick and brilliant, showcasing even white teeth. “Absolutely.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eva nearly growled at her friend. Peece was bound to stay if they offered him food, but there was no getting around it. She retreated behind the island counter but not before noticing the flash of interest in Adam’s eyes when he looked at Beth. A guy would have to be dead not to notice her statuesque friend. “Mr. Peece, this is Beth Ryken, my roommate.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Nice to meet you.” Adam extended his hand.")])]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Beth took it, and her long blond hair fell around her face, making her look even more angelic. “Have a seat.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eva might have been dazzled at first—it wasn’t every day a male-model type stopped in for visit—but she’d gathered her wits. “Mr. Peece—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Call me Adam.” He slipped onto a stool tucked under the island counter’s generous overhang.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eva gave him a weak smile. “Since you’re here, I can show you what we’ll be working on together in February. Pruning tools, the trees…that sort of thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Let him warm up a minute, Eva.” Beth gave her a pointed look that said “play nice” as she set down the tray loaded with a coffee service and a plate of scones.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The oven timer buzzed, announcing more scones were done. Eva slipped on her oven mitts. “Excuse me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Take your time.” Adam poured himself a cup of coffee.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eva pulled out the cookie sheets and glanced at Beth, who nodded toward their guest. She turned to catch Adam’s reaction.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His eyes were closed and a satisfied smile curved his shapely lips. “These are amazing.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His obvious pleasure did funny things to Eva. How could she hold a grudge against a guy who loved her baked goods? Not to mention that she’d agreed to work for him. That should teach her not to accept employment without a face-to-face interview. Not that she had much of a choice after he’d named her wages. She needed the money.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Made with Marsh cherries,” Beth added.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Adam’s eyes opened. “Canned?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eva set aside her oven mitts. “Dried. They’re what’s left of last year’s pitiful harvest.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Your father told me about the killing frost last year. Tough loss.” Adam stirred cream into his coffee.")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eva clenched her teeth. If only they’d had a bumper crop, it might have made a difference. Instead, Peece had swooped in like a bird of prey sighting a quick kill. He bought up the orchard, enabling her parents to pay off their past-due mortgage and commercial note. Even after leaving the farmhouse to her and giving her brothers money, her folks had enough left over to retire modestly in the Florida Keys. Making everyone happy.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Except her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eva shook off the thought. “They’re your cherries now, so you can process them however you like.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A moment of awkward silence hung in the air.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And Beth chose that moment to leave. “I have papers to grade, so I’ll leave you two to discuss business. Nice to meet you, Adam.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He gave her a wide smile. “You, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eva swallowed the urge to ask Beth to stay. Adam Peece made her nervous. But then so did most men close enough to her twenty-five years of age.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She eyed Adam as he reached for another scone. “Your father said you’d taken the sale hard. I hope we can get beyond that working together.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eva pursed her lips to stop the sarcastic retort poised for takeoff. Who was he to commiserate? She felt the corner of her eye twitch as she stared him down. Pretty hard to do when his attention was wrapped up in what he was eating.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What else are in these?” He held up half a scone and examined it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“White chocolate.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Wow. They’re really good.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("She knew real appreciation when she heard it, but she hadn’t expected to be warmed by it. “Now then, Mr. Peece, ")]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("did you have some questions about the upcoming season? Questions about our conversation this morning?”")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His laser blues locked on to her, trapping her. “My father is Mr. Peece. I’m Adam.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eva looked away. She didn’t feel comfortable using his first name. It sounded ridiculous considering hers. Adam and Eva. Cute. Calling him Adam rang so informal and friendly. He’d have to earn her respect and friendship before she doled it out.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Look, Peece, this isn’t easy for me. Working for you on "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("my")]), _vm._v(" family’s farm. It’s going to take some getting used to.” Tracing the rim of her grandmother’s plate with her fingertip, she glanced up at him to gauge his reaction. Would he take offense?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("No. In his eyes she read understanding.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Adam smiled at Eva. He liked the way she used his last name. From her it sounded saucy, even though he knew she used it to show that she meant business. He’d expected some reservation from her but not this stark vulnerability underneath a brave front that bordered on cockiness.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Adam leaned back, hooking his knee with both hands. “Working with people, I’ve gotten used to a lot of smoke blowing. Thanks for being honest with me. I’ll be honest, too. I don’t want to make this any harder for you. I’ve got an employment contract for you in the car instead of that fax I sent. After we sign off, I’d like to walk around the orchard on my own.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He’d rushed over here from his town house intent on seeing his land in the dead of winter. He’d seen the lights on in the kitchen of the farmhouse and known he should meet Eva in person. He couldn’t wait to get started, discuss the seasonal duties, the whole process. He couldn’t afford to waste time. He had one season, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("this season,")]), _vm._v(" to prove himself to his father.")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Okay. No problem.” Her eyes matched the copper-brown color of her hair and he thought they’d softened toward him. A little.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Adam knew women hit the salons, but Eva Marsh didn’t strike him as one of them. She didn’t wear a trace of makeup that he could see. She didn’t need to. She was small, reaching all of maybe five foot two. And awfully cute wearing an apron covered with embroidered cherries and a smudge of flour on her cheek.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He took a sip of his coffee before he brushed off that flour. “Your father mentioned something about you starting a bed-and-breakfast. When do you plan to do that?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eva’s mouth had thinned, the softness gone. “For now, that’s on hold.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Adam took another bite of his scone. Too bad Eva wasn’t as sweet as her baked goods. “Your dad’s the reason I hired you. Bob Marsh said you were the best person for the job.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eva looked straight through him as if measuring him and then finding him lacking. He’d seen that look a million times from his dad, but it still pinched. He wasn’t going to let Eva’s wariness stop him from learning everything he could from her. With God’s help, he wasn’t going to let anything stop him from making this work.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Adam nodded. “With the orchard right here, maybe you can do both.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ll keep that in mind.” Again the impatient glare before looking down at the plate of scones.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The dark fringe of her eyelashes curled against the swell of her cheeks. She had seriously long lashes and a few light freckles on her nose. Then she looked him square in the eye. “Look, I don’t mean to be so touchy, but it’s been a rough day. My bank shot down my loan application. I need this job and I’ll do my best as your farm manager.”")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Again Adam nodded while something protective stirred deep inside him. He’d erase that furrow in her brow if he could. “Good. I’m looking forward to learning everything I can from you about this orchard. I want our working relationship to be open and relaxed. I’m going to ask you a ton of questions, but I’m committed to an entire season of getting my hands dirty.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She didn’t look like she believed him. “It takes more than one season.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m sure it does.” After one season, he’d know if acting on his childhood dream was the right direction after so many failed attempts to find his niche. This time his father had thrown down the gauntlet. Success meant Adam could finally walk away from Peece Canning Company. Fail, and he’d lose it all.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eva brushed a loose strand of her stick-straight hair off her forehead. The rest was tied into a messy ponytail. “Well, I guess we’ll have to see how it goes then, won’t we?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Adam knew that was his cue to go get the contract and wrap up this meeting, but he felt an odd urge to stay. Eva’s cluttered kitchen was warm and smelled good. It reminded him of his grandparents’ farmhouse where he’d spent summers as a kid. That had been the only place where his mom used to bake. The only place he’d ever felt as if he truly belonged.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Adam knew better than to overstay his welcome. When it came to women, Adam never stayed. Not long anyway. “True. Thanks, Eva. It was nice to finally meet you.” He hooked his thumb toward the porch. “If you don’t mind, I’ll get our contract and then take that walk.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He extended his hand.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("This time she took it, but when he noticed the softness ")]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("of her skin, she pulled back. “The snow’s deep out there. You’re likely to mess up those slick leather boots.”")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thanks, but I have more.” He reached for another scone. “Mind if I take one for the road?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eva gave him a hint of a smile that revealed a dimple in her left cheek. She was impossibly cute. A real farm girl. “Go ahead.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Adam shrugged into his coat, wondering why he didn’t want to leave when Eva Marsh clearly wanted him gone. He went to the door and opened it. Snow spilled in from a good two-foot drift. The snowfall had grown heavier and the wind whipped. “Uh, Eva? I don’t think I’m going anywhere.”")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eva didn’t know what to do with Adam Peece, but she let him stay and watch her bake more scones. He might not be a big man, but he still managed to fill the kitchen with his presence. His classic, defined features begged admiration, and she’d looked her fair share.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("After they’d signed two copies of their employment contract, they discussed the first pruning chores of the season. Then Beth had joined them for a quick dinner of leftover lasagna and salad, but Adam still asked a million questions about growing up on a fruit farm. His manners were polished but relaxed and he’d charmed them both.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When he politely excused himself from the table to take a phone call on his cell, Beth leaned forward and whispered, “I think he likes you, Eva.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She rolled her eyes. “Oh, please.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m serious. He keeps checking you out.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Right.” He was probably judging her like she’d taken stock of him. It wasn’t as if she was anything to look at wearing an oversize sweatshirt the color of mud.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("Beth smiled. “You’re lucky he’s too short for me, or I ")]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("might be interested. He’s totally yummy with all that dark hair.”")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Too long.” Eva didn’t want to admit that his hair looked good even though he wore it longer than she liked. She’d always gone for the clean-cut, jock types.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re crazy,” Beth said with a giggle.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Adam entered the kitchen, cutting off their whispers.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Did you let your girlfriend know where you are?” Beth asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eva shook her head. Her roommate didn’t have a subtle bone in her body. Raised by an indulgent mother and a police officer dad, Beth’s practical streak leaned toward saying whatever popped into her head.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Adam laughed as he slipped back into his chair. “I don’t have a girlfriend. But I’m supposed to meet up with some friends to ski tonight. My family has a town house at Star Mountain.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Of course he did. That was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("the")]), _vm._v(" place to ski, even though it was almost an hour south. She should have pegged him a skier. Eva had never liked the party atmosphere of most slopes, but Adam probably fit right in. His manner might be easygoing, but she sensed intensity simmering beneath that carefree charm.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When Adam aimed his attention on her, Eva felt him tune in as if she were the only woman in the world. It was a heady feeling. And it was no wonder he’d been considered one of Detroit’s most eligible bachelors.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She’d searched on Google Adam Peece’s name. As heir to the Peece canning kingdom, Adam got around. In the Detroit society columns he’d been linked with models and wealthy downstate socialites and was even rumored to have dated the daughter of a Hollywood actor. Contrary to what her roommate thought, Eva knew a guy like Adam wouldn’t give her a passing glance.")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’ll have plenty of fresh powder after today,” Beth added.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Do you ladies like to ski?” Adam ran his fingers through dark hair that ended just below the line of his jaw. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Pretty boy")]), _vm._v(" came to mind, but a deep cleft in his chin took care of keeping his face decidedly masculine.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No,” Eva answered too quickly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“When I have time.” Beth flashed her an odd look.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What do you ladies do for fun?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Beth laughed. “Fun? What’s that, right, Eva?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eva shook her head. “I think I’ve forgotten.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t you two go out?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Beth got up from the table, taking her plate to the sink. “I’m getting my master’s degree, and ever since Eva’s parents gave her this house, she’s worked on it nonstop. Painting, putting up wallpaper, you name it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Adam gaze pierced her. “That’s right, the bed-and-breakfast. You’ve got some stiff competition with the resorts around here.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eva felt her defenses rise. Pursuing a bed-and-breakfast was perfect considering the incredible views from the farmhouse. Besides, she was a trained pastry chef who wanted to bake on her own terms. “Exactly why I think it will do well. This is a quiet place away from noisy lakeside accommodations and it happens to be surrounded by a cherry orchard.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And romantic, don’t you think?” Beth said. “Perfect for honeymooners, especially when the cherry blossoms are in bloom.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eva could have clocked her. She didn’t want to think of anything remotely romantic when it came to Adam. “We’re not far from the beaches. Plus, there are several vineyards nearby.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Too bad there isn’t a ski hill closer for winter business.”")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We have cross-country trails on the bike path.” Besides, Eva planned to cater to families, couples, honeymooners and other safe people. Not a bunch of rowdy partiers. Not guys like Peece booking her rooms.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He shrugged. “That’s cool. It’s definitely a playground up here.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Considering what she’d read about him, he qualified as one of the players. The sound of the wind wailing outside covered a stretch of silence.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well, I have to study, so I better get to it. Good night, Adam.” Beth made her escape, leaving Eva alone with him once again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Want some help with the dishes?” he finally asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sure.” Eva got up from the table. She wasn’t about to get cozy with him in the living room, so she might as well let him help her load the dishwasher.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Who are all the scones for?” Adam handed her a dish.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She stacked plates into the bottom rack. “My aunt Jamee. She’s catering a women’s group breakfast. I’ll deliver them in the morning.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Where’d you learn to bake?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She knew he was making polite small talk in an attempt to be nice. But Eva didn’t feel nice. The large kitchen that doubled as her office was her favorite room in the house, but tonight his deliciously expensive cologne blended with the oven-warmed air to suffocate her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eva let out a short sigh. “My aunt’s catering business is where I got my start. I helped her out on weekends when I wasn’t needed in the orchard. I love to bake, so I went to college in Traverse City for culinary arts. I worked the resorts awhile and then went to New York City to study pastry. I came home when my folks told me they were selling the orchard.”")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Adam smiled. “In hopes of talking them out of it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eva’s gaze flew to his. Too bad she’d been too late. Not that she could have changed anything. Eva wouldn’t hold her parents back from their dreams, even if it meant losing part of her own.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Your dad told me at the closing that you were the only one of his kids who’d miss the orchard. He said you have cherry juice pumping through your veins.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eva shut the dishwasher door too hard and then flipped the switch. “You’re pretty chummy with my dad, aren’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Adam shrugged. “Your father’s a nice guy. He took the time to introduce me around to the local processors in an attempt to smooth my path. We met several times before and after he agreed to sell.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("No doubt the price was higher than her father could refuse. Just like the salary Adam had promised her. After a few months with a steady income, maybe she could try again for that loan.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yeah, well, my dad talks too much.” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("And so do you.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Adam gave her another soft laugh. “Your father’s proud of you. You’re fortunate.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eva wasn’t in a count-your-blessings kind of mood. Adam’s easygoing charm challenged her fortified walls. Her carefully built up guard. Working for him was one thing. She didn’t want to like him, too. “Thanks. Why don’t we check out the weather report?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t worry, Eva. I’ll be on my way. The wind sounds like it’s dying down. Thanks for dinner. I’ll see you in a couple weeks.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eva nodded as she followed him to the door. The snow had stopped.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("Calling Adam Peece an attractive man was an under")]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("statement. She didn’t look forward to showing him how to run her family orchard, but she’d do her job. It didn’t help that Beth’s teasing had planted a seed of interest. A seed Eva couldn’t let grow.")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  })]), _c('a', {
    attrs: {
      "id": "page19"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page19"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-752cf844","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781426885297_ch01.vue
// module id = 81
// module chunks = 0